import { Routes, Route } from 'react-router-dom';
import { VodConsole } from './VodConsole';
import { StreamingLandingGate } from '../streaming/StreamingLandingGate';

/**
 * Cloud Encoding (VOD transcoding) module, per provisioned service.
 *
 *   /services/vod/:serviceId → console for that encoding service
 *   /services/vod            → landing gate: redirects into the console when
 *                               the org already has a Lens service, otherwise
 *                               shows the activation hero.
 */
export function VodPage() {
  return (
    <Routes>
      <Route path=":serviceId/*" element={<VodConsole />} />
      <Route index element={<StreamingLandingGate provider="lens" />} />
    </Routes>
  );
}

export default VodPage;
